import React from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import TextInput from "../../input/TextInput";
import NumberInput from "../../input/NumberInput";

const schema = yup.object({
  name: yup.string().required("Vui lòng nhập tên loại xe"),
});

function FormDMLOAIXE({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    name: "",
    so_ghe: "",
    gia_ve: "",
    so_tang: "",
    so_hang: "",
    so_day: "",
  };
  const originData = defaultValues || defaultData;

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    return values;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="500px"
      formTitle="loại xe"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <TextInput
          required
          label="Tên loại"
          labelWidth="30%"
          placeholder="Nhập tên loại xe"
          name="name"
          register={register}
          errorMessage={errors?.name?.message as string}
        />
        <NumberInput
          label="Số ghế"
          labelWidth="30%"
          placeholder="Nhập số lượng ghế"
          name="so_ghe"
          register={register}
        />
        <NumberInput
          label="Số tầng"
          labelWidth="30%"
          placeholder="Nhập số tầng"
          name="so_tang"
          register={register}
        />
        <NumberInput
          label="Số dãy"
          labelWidth="30%"
          placeholder="Nhập số dãy"
          name="so_day"
          register={register}
        />
        <NumberInput
          label="Số hàng"
          labelWidth="30%"
          placeholder="Nhập số hàng"
          name="so_hang"
          register={register}
        />
      </Stack>
    </ModalForm>
  );
}

export default FormDMLOAIXE;
